import axios from 'axios';
import global from '../global';

const idUserTrack = global.identifierUser;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    identifier_user: idUserTrack ? idUserTrack : '',
  },
});

export default api;
